module.exports = __webpack_public_path__ + "static/media/logo-white.a80cd7a7.svg";